module.exports = __webpack_public_path__ + "assets/img/jiagou1.0a484162.svg";